import { useEffect } from "react";
import { seo, siteUrl, structuredData } from "../config/seo";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const Seo = () => {
  useEffect(() => {
    document.title = seo.title;
    document.documentElement.lang = "en";

    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "keywords", seo.keywords);
    upsertMeta("name", "author", seo.author);
    upsertMeta("name", "robots", "index, follow, max-image-preview:large");
    upsertMeta("name", "googlebot", "index, follow");

    upsertLink("canonical", siteUrl);

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", siteUrl);
    upsertMeta("property", "og:title", seo.title);
    upsertMeta("property", "og:description", seo.description);
    upsertMeta("property", "og:image", seo.ogImage);
    upsertMeta("property", "og:site_name", seo.siteName);
    upsertMeta("property", "og:locale", seo.locale);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:site", seo.twitterHandle);
    upsertMeta("name", "twitter:creator", seo.twitterHandle);
    upsertMeta("name", "twitter:title", seo.title);
    upsertMeta("name", "twitter:description", seo.description);
    upsertMeta("name", "twitter:image", seo.ogImage);

    const scriptId = "portfolio-json-ld";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);
  }, []);

  return null;
};

export default Seo;
